import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Header from '../header/Header';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { API_URL } from '../../Constants';
import SideDrawer from '../header/SideDrawer';
import { Button } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { axiosClient } from '../AxiosClient';

let apiUrl = API_URL;


const ButtonPrincipal = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
});

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const ListedItem = styled(ListItemButton)({
    borderRadius: '20px',
    color: 'white',
    backgroundColor: '#1C224C',
    '&:hover': {
        backgroundColor: '#343A5F',
    },
})

const Dashboard = styled(Grid)(({theme}) => ({
    gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 250px), 1fr))",
    display: "grid",
    gap: "16px",
    width: "85%",
    marginTop: "32px",
    [theme.breakpoints.up('lg')]: {
        gridTemplateColumns: "repeat(4, minmax(min(100%, 250px), 1fr))",
    }
}))

const bull = (
    <Box
        component="span"
        sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
    >
        •
    </Box>
);

const card = (value, name) => {
    return (<Card >
        <CardContent>
            <Typography variant="h5" component="div">
                {value}
            </Typography>
            <br />
            <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                {name}
            </Typography>
        </CardContent>
    </Card>)

}

const ButtonItem = styled(Button)({
    flexGrow: 0,
    gap: '10px',
    backgroundColor: '·fafafa',
    color: '#161e55',
    margin: '0px 1rem',
    textDecorationLine: 'underline',
    fontWeight: 'bold',
    fontSize: '1rem',
    '&:hover': {
        backgroundColor: '#A8C8AF',
        color: 'white'
    },
});

const drawerWidth = 240;

export default function Statistics() {

    const [commercesQuantity, setCommercesQuantity] = useState(0);
    const [presentCommerces, setPresentCommerces] = useState(0);
    const [activeCommerces, setActiveCommerces] = useState(0);
    const [feasibilibyOverCommerces, setFeasibilibyOverCommerces] = useState(0);
    const [approvedOverFeasibility, setApprovedOverFeasibility] = useState(0);
    const [approvedOverCredits, setApprovedOverCredits] = useState(0);
    const [averageTicket, setAverageTicket] = useState(0);
    const [carteraGenerada, setCarteraGenerada] = useState(0);
    const [commercesGenerators, setCommercesGenerators] = useState(0);
    const [monthlyPlacement, setMonthtlyPlacement] = useState(0);
    const [averageQuotas, setAverageQuotas] = useState(0);
    const [creditsGeneratesMonthly, setCreditsGeneratesMonthly] = useState(0);
    const [rateApproval, setRateApproval] = useState(0);
    const [delayThirty, setDelayThirty] = useState(0);
    const [delayThirtySixty, setDelayThirtySixty] = useState(0);
    const [delaySixtyNinety, setDelaySixtyNinety] = useState(0);
    const [delayNinety, setDelayNinety] = useState(0);
    const [title, setTitle] = useState("Indicadores Generales");
    const [cities, setCities] = useState([]);
    const [city, setCity] = useState("");
    const [industries, setIndustries] = useState([]);
    const [industry, setIndustry] = useState("");

    const IndicatorGeneral = () => {
        // GET CANTIDAD DE COMERCIOS
        axiosClient.get('/v1/commerces/quantity')
        .then(response => {
            setCommercesQuantity(response.data);
        })
        .catch(error => {
            if(error.response) {
                console.log("ERROR GET - /v1/commerces/quantity");
            } else {
                console.log("Bad petition:" + error.message);
            }
        });

        // GET COMERCIOS CON ALGUNA SOLICITUD
        axiosClient.get('/v1/commerces/commercesPresent')
        .then(response => {
            setPresentCommerces(response.data);
        })
        .catch(error => {
            if(error.response) {
                console.log("ERROR GET - /v1/commerces/commercesPresent");
            } else {
                console.log("Bad petition:" + error.message);
            }
        });

        // GET COMERCIOS ACTIVOS (CON ALGUN CREDITO ACTIVO)
        axiosClient.get('/v1/commerces/activeCommerces')
        .then(response => {
            setActiveCommerces(response.data);
        })
        .catch(error => {
            if(error.response) {
                console.log("ERROR GET -/v1/commerces/activeCommerces");
            } else {
                console.log("Bad petition:" + error.message);
            }
        });

        // GET COMERCIOS GENERADORES
        axiosClient.get('/v1/credits/commercesGenerator')
        .then(response => {
            setCommercesGenerators(response.data);
        })
        .catch(error => {
            if(error.response) {
                console.log("ERROR GET /v1/credits/commercesGenerator");
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET TICKET PROMEDIO
        axiosClient.get('/v1/credits/average-ticket')
        .then(response => {
            setAverageTicket(response.data);
        })
        .catch(error => {
            if(error.response) {
                console.log("ERROR GET - /v1/credits/average-ticket");
            } else {
                console.log("Bad petition:" + error.message);
            }
        });

        // GET CARTERA GENERADA
        axiosClient.get('/v1/credits/cartera-total-generated')
        .then(response => {
            setCarteraGenerada(response.data);
        })
        .catch(error => {
            if(error.response) {
                console.log("ERROR GET - /v1/credits/cartera-total-generated");
            } else {
                console.log("Bad petition:" + error.message);
            }
        });

        // GET COLOCACIÓN MENSUAL
        axiosClient.get('/v1/credits/monthly-cash-portfolio')
        .then(response => {
            setMonthtlyPlacement(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET - /v1/credits/monthly-cash-portfolio");
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET PROMEDIO CUOTAS
        axiosClient.get('/v1/quotas/average-quota')
        .then(response => {
            setAverageQuotas(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET - /v1/quotas/average-quota");
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET N° CRÉDITOS GENERADOS EN EL MES
        axiosClient.get('/v1/credits/monthly-credit-generated')
        .then(response => {
            setCreditsGeneratesMonthly(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET - /v1/credits/monthly-credit-generated");
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET TASA DE APROVACIÓN
        axiosClient.get('/v1/credits/approved-over-credits')
        .then(response => {
            setRateApproval(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET - /v1/credits/approved-over-credits");
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET CARTERA EN MORA 30 DÍAS O MENOS
        axiosClient.get('/v1/quotas/mora-thirty-days')
        .then(response => {
            setDelayThirty(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET - /v1/quotas/mora-thirty-days");
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET CARTERA EN MORA 30 A 60 DÍAS
        axiosClient.get('/v1/quotas/mora-sixty-thirty-days')
        .then(response => {
            setDelayThirtySixty(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET - /v1/quotas/mora-sixty-thirty-days");
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET CARTERA EN MORA 60 A 90 DÍAS
        axiosClient.get('/v1/quotas/mora-ninety-sixty-days')
        .then(response => {
            setDelaySixtyNinety(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET - /v1/quotas/mora-ninety-sixty-days");
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET CARTERA EN MORA 90+ DÍAS
            axiosClient.get('/v1/quotas/mora-ninety-sixty-days')
        .then(response => {
            setDelaySixtyNinety(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET - /v1/quotas/mora-ninety-sixty-days");
            } else {
                console.log("Bad request: " + error.message);
            }
        });
    }

    const IndicatorCities = (citySearch) => {
        // GET CANTIDAD DE COMERCIOS
        axiosClient.get(`/v1/commerces/city/all-commerces/${citySearch}`)
        .then(response => {
            setCommercesQuantity(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET - /v1/commerces/city/all-commerces/" + citySearch);
            } else {
                console.log("Bad petition: " + error.message);
            }
        });

        // GET COMERCIOS CON ALGUNA SOLICITUD
        axiosClient.get(`/v1/commerces/city/presentCommerces/${citySearch}`)
        .then(response => {
            setPresentCommerces(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET - /v1/commerces/city/presentCommerces/" + citySearch);
            } else {
                console.log("Bad petition: " + error.message);
            }
        });

        // GET COMERCIOS ACTIVOS (CON ALGUN CREDITO ACTIVO)
        axiosClient.get(`/v1/commerces/city/commercesActive/${citySearch}`)
        .then(response => {
            setActiveCommerces(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/commerces/city/commercesActive/${citySearch}`);
            } else {
                console.log("Bad petition:" + error.message);
            }
        });

        // GET COMERCIOS GENERADORES
        axiosClient.get(`/v1/credits/city/commercesGenerator/${citySearch}`)
        .then(response => {
            setCommercesGenerators(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/credits/city/commercesGenerator/${citySearch}`);
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET TICKET PROMEDIO
        axiosClient.get(`/v1/credits/city/average-ticket/${citySearch}`)
        .then(response => {
            setAverageTicket(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/credits/city/average-ticket/${citySearch}`);
            } else {
                console.log("Bad petition:" + error.message);
            }
        });

        // GET CARTERA GENERADA
        axiosClient.get(`/v1/credits/city/cartera-total-generated/${citySearch}`)
        .then(response => {
            setCarteraGenerada(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/credits/city/cartera-total-generated/${citySearch}`);
            } else {
                console.log("Bad petition:" + error.message);
            }
        });

        // GET COLOCACIÓN MENSUAL
        axiosClient.get(`/v1/credits/city/monthly-cash/${citySearch}`)
        .then(response => {
            setMonthtlyPlacement(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/credits/city/monthly-cash/${citySearch}`);
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET PROMEDIO CUOTAS
        axiosClient.get(`/v1/quotas/city/average-quota/${citySearch}`)
        .then(response => {
            setAverageQuotas(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/quotas/city/average-quota/${citySearch}`);
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET N° CRÉDITOS GENERADOS EN EL MES
        axiosClient.get(`/v1/credits/city/monthly-credit-generated/${citySearch}`)
        .then(response => {
            setCreditsGeneratesMonthly(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/credits/city/monthly-credit-generated/${citySearch}`);
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET TASA DE APROVACIÓN
        axiosClient.get(`/v1/credits/city/approved-over-credits/${citySearch}`)
        .then(response => {
            setRateApproval(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/credits/city/approved-over-credits/${citySearch}`);
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET CARTERA EN MORA 30 DÍAS O MENOS
        axiosClient.get(`/v1/quotas/city/mora-thirty-days/${citySearch}`)
        .then(response => {
            setDelayThirty(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/quotas/city/mora-thirty-days/${citySearch}`);
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET CARTERA EN MORA 30 A 60 DÍAS
        axiosClient.get(`/v1/quotas/city/mora-sixty-thirty-days/${citySearch}`)
        .then(response => {
            setDelayThirtySixty(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/quotas/city/mora-sixty-thirty-days/${citySearch}`);
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET CARTERA EN MORA 60 A 90 DÍAS
        axiosClient.get(`/v1/quotas/city/mora-ninety-sixty-days/${citySearch}`)
        .then(response => {
            setDelaySixtyNinety(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/quotas/city/mora-ninety-sixty-days/${citySearch}`);
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET CARTERA EN MORA 90+ DÍAS
        axiosClient.get(`/v1/quotas/city/mora-ninety-days/${citySearch}`)
        .then(response => {
            setDelayNinety(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/quotas/city/mora-ninety-days/${citySearch}`);
            } else {
                console.log("Bad request: " + error.message);
            }
        });
    }

    const IndicatorIndustry = (industrySearch) => {
        // GET CANTIDAD DE COMERCIOS
        axiosClient.get(`/v1/commerces/industry/all-commerces/${industrySearch}`)
        .then(response => {
            setCommercesQuantity(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/commerces/industry/all-commerces/${industrySearch}`);
            } else {
                console.log("Bad petition:" + error.message);
            }
        });

        // GET COMERCIOS CON ALGUNA SOLICITUD
        axiosClient.get(`/v1/commerces/industry/presentCommerces/${industrySearch}`)
        .then(response => {
            setPresentCommerces(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/commerces/industry/presentCommerces/${industrySearch}`);
            } else {
                console.log("Bad petition:" + error.message);
            }
        });

        // GET COMERCIOS ACTIVOS (CON ALGUN CREDITO ACTIVO)
        axiosClient.get(`/v1/commerces/industry/commercesActive/${industrySearch}`)
        .then(response => {
            setActiveCommerces(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/commerces/industry/commercesActive/${industrySearch}`);
            } else {
                console.log("Bad petition:" + error.message);
            }
        });

        // GET COMERCIOS GENERADORES
        axiosClient.get(`/v1/credits/industry/commercesGenerator/${industrySearch}`)
        .then(response => {
            setCommercesGenerators(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/credits/industry/commercesGenerator/${industrySearch}`);
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET TICKET PROMEDIO
        axiosClient.get(`/v1/credits/industry/average-ticket/${industrySearch}`)
        .then(response => {
            setAverageTicket(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/credits/industry/average-ticket/${industrySearch}`);
            } else {
                console.log("Bad petition:" + error.message);
            }
        });

        // GET CARTERA GENERADA
        axiosClient.get(`/v1/credits/industry/cartera-total-generated/${industrySearch}`)
        .then(response => {
            setCarteraGenerada(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/credits/industry/cartera-total-generated/${industrySearch}`);
            } else {
                console.log("Bad petition:" + error.message);
            }
        });

        // GET COLOCACIÓN MENSUAL
        axiosClient.get(`/v1/credits/industry/monthly-cash/${industrySearch}`)
        .then(response => {
            setMonthtlyPlacement(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/credits/industry/monthly-cash/${industrySearch}`);
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET PROMEDIO CUOTAS
        axiosClient.get(`/v1/quotas/industry/average-quota/${industrySearch}`)
        .then(response => {
            setAverageQuotas(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/quotas/industry/average-quota/${industrySearch}`);
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET N° CRÉDITOS GENERADOS EN EL MES
        axiosClient.get(`/v1/credits/industry/monthly-credit-generated/${industrySearch}`)
        .then(response => {
            setCreditsGeneratesMonthly(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/credits/industry/monthly-credit-generated/${industrySearch}`);
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET TASA DE APROVACIÓN
        axiosClient.get(`/v1/credits/industry/approved-over-credits/${industrySearch}`)
        .then(response => {
            setRateApproval(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/credits/industry/approved-over-credits/${industrySearch}`);
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET CARTERA EN MORA 30 DÍAS O MENOS
        axiosClient.get(`/v1/quotas/industry/mora-thirty-days/${industrySearch}`)
        .then(response => {
            setDelayThirty(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/quotas/industry/mora-thirty-days/${industrySearch}`);
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET CARTERA EN MORA 30 A 60 DÍAS
        axiosClient.get(`/v1/quotas/industry/mora-sixty-thirty-days/${industrySearch}`)
        .then(response => {
            setDelayThirtySixty(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/quotas/industry/mora-sixty-thirty-days/${industrySearch}`);
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET CARTERA EN MORA 60 A 90 DÍAS
        axiosClient.get(`/v1/quotas/industry/mora-ninety-sixty-days/${industrySearch}`)
        .then(response => {
            setDelaySixtyNinety(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/quotas/industry/mora-ninety-sixty-days/${industrySearch}`);
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        // GET CARTERA EN MORA 90+ DÍAS
        axiosClient.get(`/v1/quotas/industry/mora-ninety-days/${industrySearch}`)
        .then(response => {
            setDelayNinety(response.data);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET" + ` - /v1/quotas/industry/mora-ninety-days/${industrySearch}`);
            } else {
                console.log("Bad request: " + error.message);
            }
        });
    }

    useEffect(() => {

        if (localStorage.getItem('userUuid') == null) {
            window.location = '/admin';
        }
        IndicatorGeneral()

        //GET ALL CITIES
        axiosClient.get('/v1/commerces/all/cities')
        .then(response => {
            setCities(response.data);
            setCity(response.data[0]);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET - /v1/commerces/all/cities");
            } else {
                console.log("Bad request: " + error.message);
            }
        });

        //GET ALL INDUSTRIES
        axiosClient.get('/v1/commerces/all/industries')
        .then(response => {
            setIndustries(response.data);
            setIndustry(response.data[0]);
        })
        .catch(error => {
            if (error.response) {
                console.log("ERROR GET - /v1/commerces/all/industries");
            } else {
                console.log("Bad request: " + error.message);
            }
        });

    }, []);

    useEffect(() => {
        if(title == "Indicadores Generales") {
            IndicatorGeneral()
        } else if(title == "Indicadores Ciudades") {
            IndicatorCities(city)
        }else if(title == "Indicadores Industrias") {
            IndicatorIndustry(industry)
        }
    }, [title, city, industry])

    const changeIndicators = (title) => {
        setTitle(title)
    }

    const handleChangeCity = (event) => {
        setCity(event.target.value)
    }

    const handleChangeIndustry = (event) => {
        setIndustry(event.target.value)
    }

    var formatter = new Intl.NumberFormat('es-US', {
        style: 'currency',
        currency: 'COP',
        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    return (
        <React.Fragment>
            {/* <Box sx={{ display: 'flex' }}> */}
                {/* <CssBaseline /> */}
                {/* <Header position="fixed" /> */}
                {/* <SideDrawer currentPage={'Dashboard'}></SideDrawer> */}
                <br /><br />
                <Toolbar />
                <Box sx={{ width: '100%'}}>
                    <Stack spacing={2} >
                        <Item>Item 1</Item>
                        <Item>Item 2</Item>
                        {/* first line */}
                        <Grid container alignItems={'center'} display={'flex'} justifyContent={'center'} paddingTop={'1rem'}>
                            <ButtonItem onClick={() => changeIndicators("Indicadores Generales")}>General</ButtonItem>
                            <ButtonItem onClick={() => changeIndicators("Indicadores Ciudades")}>Ciudad</ButtonItem>
                            <ButtonItem onClick={() => changeIndicators("Indicadores Industrias")}>Industria</ButtonItem>
                        </Grid>
                        <Box display={'flex'} alignItems={'center'} justifyContent={'space-around'} paddingTop={'1rem'}>
                            <h1>{title}</h1>
                            <Box width={'40%'}>
                            {title == "Indicadores Ciudades" && 
                                <FormControl fullWidth>
                                    <InputLabel id="ciudad">Ciudad</InputLabel>
                                    <Select labelId="ciudad" id="city" label='Ciudad' value={city} onChange={handleChangeCity}>
                                        {cities.map(item => (
                                            <MenuItem key={item} value={item}>{item}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            }
                            {
                                title == "Indicadores Industrias" &&
                                <FormControl fullWidth>
                                        <InputLabel id="industria">Industria</InputLabel>
                                        <Select labelId="industria" id="industry" label='Industria' value={industry} onChange={handleChangeIndustry}>
                                            {industries.map(item => (
                                                <MenuItem key={item} value={item}>{item}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                            }
                            </Box>
                        </Box>
                        <Box container spacing={2} sx={{display: "flex", justifyContent: "center"}}>
                        <Dashboard container spacing={2}>
                                {card(commercesQuantity, "Comercios Aliados")}
                                {card(presentCommerces, "Comercios Presentes")}
                                {card(activeCommerces, "Comercios Activos")}
                                {card(commercesGenerators, "Comercios Generadores")}
                                {card(formatter.format(averageTicket), "Ticket Promedio")}
                                {card(formatter.format(carteraGenerada), "Cartera Generada")}
                                {card(formatter.format(monthlyPlacement), "Colocación Mensual")}
                                {card(averageQuotas.toFixed(7), "Promedio Cuotas")}
                                {card(creditsGeneratesMonthly, "N° Créditos Generados (Mes)")}
                                {card(rateApproval.toFixed(7), "Tasa de aprobación")}
                                {card(delayThirty, "Cartera en Mora 30 días o menos")}
                                {card(delayThirtySixty, "Cartera en Mora 30 a 60 días")}
                                {card(delaySixtyNinety, "Cartera en Mora 60 a 90 días")}
                                {card(delayNinety, "Cartera en Mora 90+ días")}
                        </Dashboard>
                        </Box>
                    </Stack>
                </Box>
            {/* </Box> */}
        </React.Fragment >
    );
}